// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconEyePath = 'M19.945 4h-2a2 2 0 0 1-1.54 1.941 9.35 9.35 0 0 0-.699-.695c.753-.719 1.239-1.89 1.239-3.246h-2c0 1.22-.592 2-1 2v.017a8.52 8.52 0 0 0-4-1.017C7.386 3 4.941 4.17 3.202 6.253L.05 10.5l3.187 4.291c1.704 2.04 4.149 3.21 6.708 3.21 2.56 0 5.004-1.17 6.743-3.255l3.153-4.246-2.162-2.91c1.335-.65 2.266-2.008 2.266-3.59Zm-4.827 9.51C13.796 15.091 11.91 16 9.945 16c-1.965 0-3.85-.908-5.138-2.446L2.54 10.5l2.232-3.01C6.095 5.907 7.98 5 9.945 5c1.965 0 3.851.907 5.138 2.446L17.35 10.5l-2.232 3.01ZM9.945 6.5c-2.206 0-4 1.794-4 4 0 2.205 1.794 4 4 4s4-1.795 4-4c0-2.206-1.794-4-4-4Zm0 6c-1.102 0-2-.897-2-2s.898-2 2-2c1.103 0 2 .897 2 2s-.897 2-2 2Z';
var IconEye = baseIcon('IconEye', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconEyePath
});
export default IconEye;
//# sourceMappingURL=index.js.map